import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { Config } from '../../Config';
import DataManager from '../DataManager';

class SignOutUser {
  action() {
    const userPool = new CognitoUserPool({
      UserPoolId: Config.cognitoUserPoolId,
      ClientId: Config.cognitoClientId
    });

    const user = userPool.getCurrentUser();

    return new Promise((resolve) => {
      if (user) {
        user.signOut();
      }

      DataManager.getInstance().clearSessionData();
      resolve();
    });
  }
}

export default SignOutUser;
